import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { UilSmile } from '@iconscout/react-unicons';

const testimonials = [
  {
    image: process.env.PUBLIC_URL + '/media/user_images/karis_linkedin_photo-min.jpeg',
    topic: 'Exceptional App',
    quote: `"EYE20 GROUP's seamless process for saving and borrowing not only simplified my finances but also enabled me to invest more confidently."`,
    name: '- Daniel Kariuki',
  },
  {
    image: process.env.PUBLIC_URL + '/media/user_images/welcomeRightUpper-min.jpg',
    topic: 'A Satisfying Platform',
    quote: `"It simplified my hassle for quick finances and gave me investment confidence."`,
    name: '- Jesse Kimani',
  },
  {
    image: process.env.PUBLIC_URL + '/media/user_images/mylinkedin_photo-min.jpeg',
    topic: 'Game Changer',
    quote: `"Best financial decision I’ve made in years."`,
    name: '- David Kibobo',
  },
  {
    image: process.env.PUBLIC_URL + '/media/user_images/maina_linkedin_Photo-min.jpeg',
    topic: 'So Easy to Use',
    quote: `"Navigating finances has never been this stress-free!"`,
    name: '- David Karanja',
  },
];

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Rotate every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const { image, topic, quote, name } = testimonials[currentIndex];

  return (
    <Section id="testimonials">
      <h2>What Our Members Say</h2>
      <Card>
        <IconWrap><UilSmile size="36" color="#007bff" /></IconWrap>
        <Image src={image} alt={name} />
        <h4>{topic}</h4>
        <p>{quote}</p>
        <span>{name}</span>
      </Card>
    </Section>
  );
};

const Section = styled.section`
  padding: 4rem 2rem;
  background: #e9f1fb;
  text-align: center;

  h2 {
    font-size: 1.75rem;
    margin-bottom: 2rem;
    color: #003366;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 1.5rem;
    }
  }
`;

const Card = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 12px;
  max-width: 600px;
  margin: 0 auto;
  box-shadow: 0 8px 20px rgba(0,0,0,0.08);
  transition: all 0.3s ease;

  p {
    font-style: italic;
    margin-top: 1rem;
    font-size: 1.1rem;
  }

  h4 {
    margin-top: 1rem;
    color: #003366;
    font-size: 1.2rem;
  }

  span {
    display: block;
    margin-top: 1rem;
    font-weight: bold;
    color: #007bff;
  }

  @media (max-width: 768px) {
    padding: 1.5rem;

    p {
      font-size: 1rem;
    }

    h4 {
      font-size: 1.05rem;
    }

    span {
      font-size: 0.95rem;
    }
  }
`;

const Image = styled.img`
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 50%;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    width: 65px;
    height: 65px;
  }
`;

const IconWrap = styled.div`
  margin-bottom: 1rem;
`;

export default TestimonialsSection;
